import PropTypes from "prop-types";
import React from "react";

import { Section } from "@swa-ui/core";
import { classNames, convertToTitleCase } from "@swa-ui/string";

import styles from "./ContactInformation.module.scss";

export const ContactInformation = (props) => {
  const {
    additional,
    city,
    contactNameBold,
    contactTypelabel,
    countryFullName,
    firstName,
    lastName,
    phoneNumber,
    postalCode,
    relationship,
    stateProvidenceRegion,
    street,
    styleType,
  } = props;

  return (
    <Section className={getContactInformationClassName()}>
      {contactTypelabel && <div className={getContactTypeLabelClassName()}>{contactTypelabel}</div>}
      {renderName()}
      {relationship && <div>{convertToTitleCase(relationship)}</div>}
      {phoneNumber && <div>{phoneNumber}</div>}
      {renderAddress()}
    </Section>
  );

  function renderAddress() {
    return (
      <div>
        {street && <div>{convertToTitleCase(`${street}`)}</div>}
        {additional && <div>{convertToTitleCase(`${additional}`)}</div>}
        {city && <span>{convertToTitleCase(`${city}`)}</span>}
        {stateProvidenceRegion && <span>{`, ${stateProvidenceRegion} `}</span>}
        {postalCode && <span>{`${postalCode}`}</span>}
        {countryFullName && <div>{convertToTitleCase(`${countryFullName}`)}</div>}
      </div>
    );
  }

  function renderName() {
    return (
      firstName &&
      lastName && (
        <div className={getContactNameClassName()}>
          {convertToTitleCase(`${firstName} ${lastName}`)}
        </div>
      )
    );
  }

  function getContactInformationClassName() {
    return classNames({
      [styles.secondaryContainer]: styleType === "secondary",
    });
  }

  function getContactNameClassName() {
    return classNames({
      [styles.bold]: contactNameBold,
    });
  }

  function getContactTypeLabelClassName() {
    return classNames({
      [styles.bold]: styleType === "secondary",
      [styles.secondaryContactType]: styleType === "secondary",
    });
  }
};

ContactInformation.propTypes = {
  /** Contact person additional address detail - additional description. */
  additional: PropTypes.string,

  /** Contact person address detail - city description. */
  city: PropTypes.string,

  /** Toggle to apply bold styling for contact name field. */
  contactNameBold: PropTypes.bool,

  /** Contact type label. */
  contactTypelabel: PropTypes.string,

  /** Contact person's country full name. */
  countryFullName: PropTypes.string,

  /** Contact person firstName. */
  firstName: PropTypes.string,

  /** Contact person lastName. */
  lastName: PropTypes.string,

  /** Contact person phone number. */
  phoneNumber: PropTypes.string,

  /** Contact person address detail - postal code description. */
  postalCode: PropTypes.string,

  /** Contact person relationship description. */
  relationship: PropTypes.string,

  /** Contact person address detail - region description. */
  stateProvidenceRegion: PropTypes.string,

  /** Contact person address detail - street description. */
  street: PropTypes.string,

  /** Parent Guardian style type. */
  styleType: PropTypes.oneOf(["primary", "secondary"]),
};
